import { ChannelSignUp, ConsumerAccountResponse } from '../../types'
import { Country, Money, SupportedLocale } from '@afterpay/types'

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P]
}

export interface UpdateAccountRequest {
  body: DeepPartial<ConsumerAccountResponse>
}

export interface UpdateAccountDetailsRequest {
  givenNames: string
  otherGivenNames: string
  surname: string
  dateOfBirth: string
  address1: string
  address2: string
  area2: string | null
  countryCode: Country
  postcode: string
  state: string
  suburb: string
  preferredLocale: SupportedLocale
  creditPolicyAgree: boolean
}

// TODO clean this code once it's fully rollout https://apglobal.atlassian.net/browse/IDENTITY-395 */
export interface SelectCloseAccountReasons {
  DO_NOT_WANT_USE_APT: string
  NEED_BREAK_FROM_APT: string
  APPLYING_FOR_NEW_MORTGAGE: string
  UNABLE_TO_SHOP_RIGHT_NOW: string
}

export const SELECT_CLOSE_ACCOUNT_REASONS = {
  DO_NOT_WANT_USE_APT: `I don't want to use Afterpay anymore`,
  NEED_BREAK_FROM_APT: 'I need a break from Afterpay',
  APPLYING_FOR_NEW_MORTGAGE: `I'm applying for a new mortgage`,
  UNABLE_TO_SHOP_RIGHT_NOW: `I'm unable to shop right now`,
} as const

export type SelectCloseAccountReasonType = typeof SELECT_CLOSE_ACCOUNT_REASONS
export type SelectCloseAccountReasonKeys = keyof SelectCloseAccountReasonType
type SelectCloseAccountReasonProps = SelectCloseAccountReasonType[SelectCloseAccountReasonKeys]

export enum CloseAccountReasons {
  BreakFromAfterpay = 'BreakFromAfterpay',
  ApplyingForLoan = 'ApplyingForLoan',
  MovingToDifferentService = 'MovingToDifferentService',
  Other = 'Other',
}

export interface DeactivateAccountRequest {
  body: {
    deactivateReason: SelectCloseAccountReasonProps | CloseAccountReasons
  }
}

export interface CloseAccountRequest {
  closeReason: CloseAccountReasons
}
export interface CloseAccountEligibleResponse {
  eligible: boolean
  nonZeroBalanceOrders: boolean
  pendingOrders: boolean
  activePlusSubscription: boolean
  pendingDisputes: boolean
  pendingChargebacks: boolean
}

export interface RangeValue {
  min: Money | null
  max: Money | null
}

export enum QuestionType {
  RANGE = 'RANGE',
  STRING = 'STRING',
}

export enum StringAnswerValue {
  YES = 'YES',
  NO = 'NO',
}

export interface BaseQuestion {
  questionId: string
  type: QuestionType
}

export interface RangeQuestion extends BaseQuestion {
  type: QuestionType.RANGE
  rangeValue: RangeValue | null
}

export interface StringQuestion extends BaseQuestion {
  type: QuestionType.STRING
  stringValue: StringAnswerValue
}

export type Question = RangeQuestion | StringQuestion

export interface UnsuitabilityQuestionsRequest {
  answers: Question[]
  channel?: ChannelSignUp
}

export interface CreditContractDocumentResponse {
  renderedHtml: string
}

export interface CreditContractRequest {
  source: 'checkout' | 'portal'
}
